<template>
    <div v-if="showSlider" class="pgapp-segment sticky">
        <div @click="slidePrev" class="ion-slide-nav ion-slide-nav-left" :class="{'visible': showLeftButton}">
            <svg class="icon icon-chevron-left">
                <use xlink:href="#icon-chevron-left"></use>
            </svg>
        </div>
        <ion-slides ref="slides"
                    @ionSlideDidChange="slideChanged"
                    :options="slideOpts"
                    mode="md">
            <ion-slide v-for="(item,index) in categories" @click="goToSegment(item.slug)" :key="index">
                <ion-segment-button mode="md" :data-active="category == item.slug ? true : false">
                    <ion-label>{{ item.name }}</ion-label>
                </ion-segment-button>
            </ion-slide>
        </ion-slides>
        <div @click="slideNext" class="ion-slide-nav ion-slide-nav-right" :class="{'visible': showRightButton}">
            <svg class="icon icon-chevron-right">
                <use xlink:href="#icon-chevron-right"></use>
            </svg>
        </div>
    </div>
</template>

<script>
    import api from '@/services/Api';
    import { mapState } from 'vuex';

    export default {
        name: 'AcademySegment',
        computed: {
            ...mapState({
                loading: state => state.academies.loading,
                categories: state => state.academies.single ? state.academies.single.bookmarks : [],
                category: state => state.academies.category
            }),

            showSlider(){
                return this.categories.length > 0 ? true : false
            },

            showLeftButton(){
                return this.sliderIndex != 0 ? true : false
            },

            showRightButton(){
                return !this.sliderEnd ? true : false
            },

            categorySliderIndex(){
                return this.showSlider ? this.categories.findIndex(item => item.slug == this.category) : null
            },

            sliderCurrentSlug(){
                return this.showSlider ? this.categories[this.categorySliderIndex].slug : null
            },

            sliderFirstVisibleSlug(){
                return this.showSlider ? this.categories[this.sliderIndex].slug : null
            }
        },
        data(){
            return {
                // helpers
                sliderIndex: 0,
                sliderLength: 0,
                sliderEnd: false,
                // options
                slideOpts: {
                    slidesPerView: 2,
                }
            }
        },
        watch: {
            // update slider options after vuex categories are set
            showSlider(){
                this.fixSliderOptions()
            },
        },
        mounted(){
            this.fixSliderOptions()
            // slide to current category name
            setTimeout(() => {
                this.slideTo()
            }, 300)
        },
        methods: {
            goToSegment(slug) {
                let routeName = '';
                let routeSlug = this.$route.params.slug;
                let id = slug;
                // switch between: AcademySingle, AcademyNews, AcademyBookmark
                if(slug == 'start'){
                    routeName = 'AcademySingle'
                }else if(slug == 'news'){
                    routeName = 'AcademyNews'
                }else{
                    routeName = 'AcademyBookmark'
                }
                this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_SET_CATEGORY', slug);
                this.$router.push({name: routeName, params: { slug: routeSlug, id: id }}).catch(err => {})
            },
            slideChanged(){
                // update slider helpers
                this.$refs.slides.getActiveIndex().then(index => {
                    this.sliderIndex = index
                })
                this.$refs.slides.length().then(length => {
                    this.sliderLength = length
                })
                this.$refs.slides.isEnd().then(bool => {
                    this.sliderEnd = bool
                })
            },
            slideNext(){
                this.$refs.slides.slideNext();
            },
            slidePrev(){
                this.$refs.slides.slidePrev();
            },
            slideTo(){
                if(!this.$refs.slides) return
                this.$refs.slides.slideTo(this.categorySliderIndex);
            },
            fixSliderOptions() {
                this.$nextTick(() => {
                    if(!this.$refs.slides) return
                    this.$refs.slides.options = this.slideOpts;
                });
            }
        }
    }
</script>